<app-row-header (toggleMenu)="toggleMenu()">{{ 'FOOTER.menu' | translate }}</app-row-header>

@if (showMenuContent) {
    <ul>
        @for (item of footerMenu; track item) {
            <li class="my-3" app-footer-menu-item [item]="item"></li>
        }
    </ul>
}
